type ToastProps = { children: React.ReactNode };

export default function Toast({ children }: ToastProps) {
  return (
    <div className="toast">
      <span className="dot" />
      <span>{children}</span>
    </div>
  );
}
